/**
 * AB product gallery: sync thumbnail "selected" state with main slider (theme.js only
 * updates active-thumb on thumb click, not on main prev/next). Strip stale .activeSlide
 * from Liquid so it doesn't fight Slick.
 *
 * Sticky cart (.stickyCart--pdp): show after scrolling past .product-action; sync with main form.
 */
(function ($) {
  /**
   * After theme.js `.text()` on #AddToCartText (destroys atc structure), re-copy main HTML
   * to the sticky CTA and match disabled state. Used from bindStickyCartAb + _updateAddToCart.
   */
  function registerAbSyncStickyAtc($section) {
    var sectionId = $section.attr('data-section-id');
    if (!sectionId) return;
    var ns = 'abStickyAtc-' + sectionId;
    if ($section.data(ns)) return;
    $section.data(ns, true);
    var sync = function () {
      var $mainT = $section.find('#AddToCartText-' + sectionId).first();
      var $stT = $('#AddToCartText-' + sectionId + '-ab');
      var $mBtn = $section.find('#AddToCart-' + sectionId).first();
      var $sBtn = $('#AddToCart-' + sectionId + '-ab');
      if ($mBtn.length && $sBtn.length) {
        $sBtn.prop('disabled', $mBtn.prop('disabled'));
      }
      if ($mainT.length && $stT.length && $mainT.hasClass('product-atc-text') && $stT.hasClass('product-atc-text')) {
        $stT.html($mainT.html());
      }
    };
    if (!window._abSyncStickyBySection) {
      window._abSyncStickyBySection = {};
    }
    window._abSyncStickyBySection[sectionId] = sync;
    if (!window.abSyncStickyAtcFromMain) {
      window.abSyncStickyAtcFromMain = function (id) {
        if (id && window._abSyncStickyBySection && window._abSyncStickyBySection[id]) {
          window._abSyncStickyBySection[id]();
        }
      };
    }
  }

  function syncStickyBySectionIdFromDom(id) {
    if (!id) return;
    var $m = $('#AddToCartText-' + id);
    var $s = $('#AddToCartText-' + id + '-ab');
    if ($m.length && $s.length && $m.hasClass('product-atc-text') && $s.hasClass('product-atc-text')) {
      $s.html($m.html());
    }
    var $mBtn = $('#AddToCart-' + id);
    var $sBtn = $('#AddToCart-' + id + '-ab');
    if ($mBtn.length && $sBtn.length) {
      $sBtn.prop('disabled', $mBtn.prop('disabled'));
    }
  }

  function bindStickyCartAb($section) {
    if ($section.data('stickyCartAbBound')) return;
    var sectionId = $section.attr('data-section-id');
    if (!sectionId) return;
    var $sticky = $('.stickyCart--pdp[data-section-id="' + sectionId + '"]');
    if (!$sticky.length) return;
    $section.data('stickyCartAbBound', true);
    registerAbSyncStickyAtc($section);

    var $productAction = $section.find('.product-action').first();
    var $mainForm = $section.find('form.productForm').first();
    var $mainQty = $mainForm.find('input.qty[name="quantity"]');
    var $mainSelect = $section.find('#ProductSelect-' + sectionId).first();
    var $stickyQty = $sticky.find('input.qty[name="quantity"]');
    var STICKY_ATC_OPEN = 'stickyCart--pdp--open';
    var STICKY_ATC_MS = 400;
    var stickyPaddingTimer = null;
    function stickyMotionHideMs() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return 0;
      }
      return STICKY_ATC_MS;
    }

    function setBodyPaddingForSticky() {
      $('body.template-product').css('padding-bottom', $sticky.outerHeight() || 72);
    }

    function stickyShow() {
      if (stickyPaddingTimer) {
        clearTimeout(stickyPaddingTimer);
        stickyPaddingTimer = null;
      }
      $sticky.attr('aria-hidden', 'false');
      requestAnimationFrame(function () {
        $sticky.addClass(STICKY_ATC_OPEN);
        setBodyPaddingForSticky();
      });
    }

    function stickyHide() {
      $sticky.attr('aria-hidden', 'true');
      $sticky.removeClass(STICKY_ATC_OPEN);
      stickyPaddingTimer = setTimeout(function () {
        stickyPaddingTimer = null;
        $('body.template-product').css('padding-bottom', '');
      }, stickyMotionHideMs());
    }

    function updateStickyVisibility() {
      if (!$productAction.length) return;
      var bottom = $productAction.offset().top + $productAction.outerHeight();
      var scrollY = $(window).scrollTop();
      var show = scrollY > bottom - 16;
      if (show) stickyShow();
      else stickyHide();
    }

    $(window).on('scroll.stickyCartAb resize.stickyCartAb', updateStickyVisibility);
    updateStickyVisibility();

    function syncStickyButtonFromMain() {
      if (window._abSyncStickyBySection && window._abSyncStickyBySection[sectionId]) {
        window._abSyncStickyBySection[sectionId]();
      }
    }

    function stickyUpdateImage(variant) {
      if (!variant) return;
      var $img = $sticky.find('.product-featured-img').first();
      if (!$img.length) return;
      var src = null;
      if (variant.featured_image && variant.featured_image.src) {
        src = variant.featured_image.src;
      } else if (variant.featured_media && variant.featured_media.preview_image) {
        src = variant.featured_media.preview_image.src;
      }
      if (!src) return;
      if (typeof theme !== 'undefined' && theme.Images && theme.Images.getSizedImageUrl) {
        $img.attr('src', theme.Images.getSizedImageUrl(src, '60x60'));
      } else {
        $img.attr('src', src.replace(/(\.[^\.]*$|$)/, '_60x60' + '$&'));
      }
    }

    function syncStickyFromVariant(variant) {
      if (!variant) return;
      var $stickySelect = $sticky.find('select[name="id"]').first();
      if ($stickySelect.length) {
        $stickySelect.val(variant.id);
      }
      var $selOpt = $sticky.find('.stickyOptions .selectedOpt');
      if ($selOpt.length && typeof theme !== 'undefined' && theme.Currency) {
        $selOpt.text(variant.title + ' - ' + theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      }
      stickyUpdateImage(variant);
    }

    $section.on('variantChange', function (evt) {
      setTimeout(function () {
        syncStickyButtonFromMain();
        syncStickyFromVariant(evt.variant);
        if (typeof updatePrice === 'function') updatePrice();
      }, 0);
    });

    $section.on('change input', 'form.productForm input.qty[name="quantity"]', function () {
      if ($stickyQty.length) $stickyQty.val($(this).val());
      setTimeout(function () {
        if (window.abSyncStickyAtcFromMain) window.abSyncStickyAtcFromMain(sectionId);
      }, 0);
    });

    if ($productAction.length) {
      $productAction.on('click', '.qtyField a, .qtyField .qtyBtn, .qtyBtn', function () {
        setTimeout(function () {
          if ($stickyQty.length && $mainQty.length) $stickyQty.val($mainQty.val());
          if (window.abSyncStickyAtcFromMain) window.abSyncStickyAtcFromMain(sectionId);
        }, 0);
      });
    }

    /**
     * Sticky: theme.js only updates the sticky .qty. Sync that value to the main form (authoritative
     * for /cart/add) in bubble order after theme, before pdp's document updatePrice. Without this,
     * updatePrice (and former main→sticky sync in abApplyAtcLine) reverted the sticky.
     */
    $sticky.on('click', '.qtyBtn', function () {
      if (!$mainQty.length) return;
      var v = $sticky.find('input.qty[name="quantity"]').val();
      if (v == null || v === '') return;
      $mainQty.val(v).trigger('input').trigger('change');
    });

    $sticky.on('change input', 'input.qty[name="quantity"]', function () {
      $mainQty.val($(this).val()).trigger('change');
      if (typeof updatePrice === 'function') updatePrice();
      setTimeout(function () {
        if (window.abSyncStickyAtcFromMain) window.abSyncStickyAtcFromMain(sectionId);
      }, 0);
    });

    $sticky.on('change', 'select[name="id"]', function () {
      var val = $(this).val();
      if ($mainSelect.length) {
        $mainSelect.val(val).trigger('change');
      }
    });

    $sticky.on('submit', 'form', function (e) {
      e.preventDefault();
      var vid = $(this).find('select[name="id"]').val();
      var qty = $(this).find('.qty').val() || 1;
      if ($mainSelect.length) {
        $mainSelect.val(vid).trigger('change');
      }
      setTimeout(function () {
        $mainQty.val(qty);
        if (typeof updatePrice === 'function') updatePrice();
        $section.find('#AddToCart-' + sectionId).first().trigger('click');
      }, 0);
    });

    if ($mainQty.length && $stickyQty.length) {
      $stickyQty.val($mainQty.val());
    }
    syncStickyButtonFromMain();
    setTimeout(syncStickyButtonFromMain, 200);
  }

  function syncThumbActive($section, slick, currentSlide) {
    var sectionId = $section.attr('data-section-id');
    if (!sectionId || !slick || slick.$slides == null) return;

    var $thumbLinks = $section.find('.product-single__thumbnail--' + sectionId);
    $thumbLinks.removeClass('active-thumb activeSlide');

    var $mainSlide = $(slick.$slides.get(currentSlide));
    var slideIdx = $mainSlide.data('slide');
    if (slideIdx === undefined) return;

    $section
      .find('.product-single__thumbnails-item[data-slide="' + slideIdx + '"] a.product-single__thumbnail')
      .addClass('active-thumb');
  }

  function bindSection($section) {
    var sectionId = $section.attr('data-section-id');
    if (!sectionId) return;

    var $primg = $section.find('.primgSlider');
    if (!$primg.length) return;

    $section.find('.product-single__thumbnail--' + sectionId).removeClass('activeSlide');

    function runSync(e, slick, currentSlide) {
      syncThumbActive($section, slick, currentSlide);
    }

    $primg.on('init.productAb', runSync);
    $primg.on('afterChange.productAb', runSync);

    if ($primg.hasClass('slick-initialized')) {
      try {
        var slick = $primg.slick('getSlick');
        syncThumbActive($section, slick, $primg.slick('slickCurrentSlide'));
      } catch (err) {
        setTimeout(function () {
          try {
            var s2 = $primg.slick('getSlick');
            syncThumbActive($section, s2, $primg.slick('slickCurrentSlide'));
          } catch (e2) {}
        }, 100);
      }
    }
  }

  $(function () {
    $('.product-template--pdp[data-section-id]').each(function () {
      registerAbSyncStickyAtc($(this));
    });
    /**
     * AB PDP: pdp-custom `updatePrice` reads the first `.product-form__input` for qty (variant select).
     * Sync `.atc-total-price` to unit (variant) × real quantity using theme.Currency.
     */
    (function abSyncAtcTotalWithQuantity() {
      if (typeof window.updatePrice !== 'function' || (window.updatePrice && window.updatePrice.__abAtcQtyPatched)) {
        return;
      }
      var orig = window.updatePrice;
      function abSectionId() {
        var el = document.querySelector('.product-template--pdp[data-section-id]');
        return el && el.getAttribute('data-section-id');
      }
      function abMainQty() {
        var s = abSectionId();
        var input =
          (s &&
            document.querySelector(
              '.product-template--pdp[data-section-id="' + s + '"] form.productForm input.qty[name="quantity"]'
            )) ||
          document.querySelector('form.productForm input.qty[name="quantity"]') ||
          document.querySelector('input#quantity[name="quantity"]') ||
          document.querySelector('.product-action .qtyField input[name="quantity"]');
        var n = parseInt(input && input.value, 10);
        return n > 0 ? n : 1;
      }
      function abParseMoneyToCents(priceString) {
        if (!priceString) return 0;
        var cleaned = String(priceString).trim();
        var symbols = [
          '$',
          '€',
          '£',
          '¥',
          'kr',
          'Ft',
          '₹',
          '₽',
          'C$',
          'A$',
          'NZ$',
          'S$',
          'HK$',
          '₩',
          '฿',
          'R$',
          'zł',
          'kč',
          '₺',
          '₴',
          '₪',
          '₫',
          '₱',
          'Rp',
          'RM',
          'лв',
          'kn',
          'lei',
          'CHF'
        ];
        symbols.forEach(function (sym) {
          cleaned = cleaned.split(sym).join('');
        });
        cleaned = cleaned.replace(/[A-Z]{3}/g, '');
        cleaned = cleaned
          .trim()
          .split(' ')
          .join('');
        if (!cleaned || cleaned.match(/^[^\d]*$/)) {
          return 0;
        }
        var digitDotOnly = cleaned.replace(/[^\d.]/g, '');
        if (digitDotOnly.indexOf(',') === -1 && /^\d{1,3}(\.\d{3})+$/.test(digitDotOnly)) {
          var mergedT = digitDotOnly.replace(/\./g, '');
          var nT = parseInt(mergedT, 10);
          if (!isNaN(nT)) {
            return nT * 100;
          }
        }
        var lastComma = cleaned.lastIndexOf(',');
        var lastDot = cleaned.lastIndexOf('.');
        var format = 'us';
        if (lastComma > lastDot && /,\d{2}([^0-9]|$)/.test(cleaned)) {
          format = 'eu';
        } else if ((cleaned.match(/,/g) || []).length > 1) {
          format = 'in';
        }
        var normalized;
        if (format === 'eu') {
          normalized = cleaned.replace(/\./g, '').replace(',', '.');
        } else if (format === 'in') {
          normalized = cleaned.replace(/,/g, '');
        } else {
          normalized = cleaned.replace(/,/g, '');
        }
        var parsed = parseFloat(normalized);
        if (isNaN(parsed)) return 0;
        return Math.round(parsed * 100);
      }
      function abGpoAddonCents() {
        var gpoMoney =
          document.querySelector('.gpo-total .gpo-total-text .money') ||
          document.querySelector('.gpo-app .gpo-total-text .money') ||
          document.querySelector('.gpo-total-text .money') ||
          document.querySelector('.gpo-total-text span');
        if (!gpoMoney) return 0;
        var addCents = abParseMoneyToCents(gpoMoney.textContent);
        return addCents > 0 ? addCents : 0;
      }
      function abVariantCents(sectionId) {
        var j = document.getElementById('ProductJson-' + sectionId);
        var sel = document.getElementById('ProductSelect-' + sectionId);
        if (!j || !sel) return 0;
        var product;
        try {
          product = JSON.parse(j.textContent);
        } catch (e) {
          return 0;
        }
        var vid = parseInt(sel.value, 10);
        var v =
          product.variants &&
          product.variants.find(function (x) {
            return x.id === vid;
          });
        if (!v) return 0;
        var pr = v.price;
        if (typeof pr === 'string' && pr.indexOf('.') >= 0) {
          pr = pr.replace(/\./, '');
        }
        return parseInt(pr, 10) || 0;
      }
      function abGetMainAtcButtons(sectionId) {
        var section = document.querySelector('.product-template--pdp[data-section-id="' + sectionId + '"]');
        var form = section && (section.querySelector('form.productForm, form[action*="/cart/add"]') || null);
        if (form) {
          var all = [].slice.call(
            form.querySelectorAll('button[name="add"].product-form__cart-submit')
          );
          if (all.length) {
            return all;
          }
        }
        return [].slice.call(document.querySelectorAll('#AddToCart-' + sectionId));
      }
      function abApplyAtcLine() {
        var sectionId = abSectionId();
        if (!sectionId) return;
        if (typeof theme === 'undefined' || !theme.Currency) return;
        var unitCents = abVariantCents(sectionId);
        if (unitCents <= 0) return;
        var lineCents = unitCents * abMainQty() + abGpoAddonCents();
        // shop.money_format may include <span class="money">; use innerHTML so it renders, not as escaped text
        var f = theme.Currency.formatMoney(lineCents, theme.moneyFormat);
        abGetMainAtcButtons(sectionId).forEach(function (btn) {
          if (!btn) return;
          var atc = btn.querySelector('.atc-total-price');
          if (atc) {
            atc.innerHTML = f;
          }
        });
        var sticky = document.querySelector('#AddToCart-' + sectionId + '-ab');
        if (sticky) {
          var stAtc = sticky.querySelector('.atc-total-price');
          if (stAtc) stAtc.innerHTML = f;
        }
        /* Do not sync main→sticky here. theme.js only changes the sticky +/−; abSyncStickyQtyFromMain
           in this path reverted the sticky to main before the main form was updated. */
      }
      function wrapped() {
        if (document.querySelector('.product-template--pdp')) {
          setTimeout(function () {
            abApplyAtcLine();
          }, 0);
          return;
        }
        return orig();
      }
      wrapped.__abAtcQtyPatched = true;
      window.updatePrice = wrapped;
      setTimeout(abApplyAtcLine, 0);
    })();

    /**
     * Re-sync discount % in the green pill: theme.js targets the first .discount-badge globally; on AB
     * we set the percent from the product section and round for display.
     */
    (function abPatchProductUpdatePricePill() {
      if (typeof theme === 'undefined' || !theme.Product || !theme.Product.prototype) return;
      var origU = theme.Product.prototype._updatePrice;
      if (typeof origU !== 'function' || origU.__abDiscountPillPatched) return;
      function patchedU(evt) {
        origU.call(this, evt);
        if (!this.$container || !this.$container.length) return;
        if (!this.$container.closest('.product-template--pdp').length) return;
        var variant = evt && evt.variant;
        if (!variant) return;
        if (variant.compare_at_price > variant.price) {
          var p =
            (variant.compare_at_price - variant.price) * 100.0 / variant.compare_at_price;
          var n = Math.round(p);
          if (n < 0) n = 0;
          this.$container.find('.product-ab-discount-badge .off > span').first().text(n);
        }
      }
      patchedU.__abDiscountPillPatched = true;
      theme.Product.prototype._updatePrice = patchedU;
    })();

    (function abPatchAddToCartTextAb() {
      if (typeof theme === 'undefined' || !theme.Product || !theme.Product.prototype) return;
      var orig = theme.Product.prototype._updateAddToCart;
      if (typeof orig !== 'function' || orig.__abPatched) return;

      /**
       * theme.js sets #AddToCartText to a single .text() string and removes .atc-total-price.
       * Rebuild product-atc-text, refresh line price, then copy HTML to the sticky CTA.
       */
      function restoreAtcTextAfterTheme(prod, evt) {
        var $c = prod.$container;
        if (!$c || !$c.length || !$c.closest('.product-template--pdp').length) return;
        var sectionId = prod.settings.sectionId;
        if (!sectionId) return;
        var $t = $(prod.selectors.addToCartText);
        if (!$t.length) return;
        var label = $.trim($t.text());
        var v = evt && evt.variant;
        $t.empty();
        $t.addClass('product-atc-text');
        $t.append($('<span class="atc-label-text" />').text(label), $('<span class="atc-total-price" />'));
        var $p = $t.find('.atc-total-price');
        if (v) {
          if (v.available) {
            var invQ = parseInt($('#pvr-' + v.id).text(), 10) || 0;
            var preOrder = v.inventory_management === 'shopify' && invQ < 1;
            if (preOrder) {
              $p.hide().empty();
            } else {
              $p.show();
            }
          } else {
            $p.hide().empty();
          }
        } else {
          $p.hide().empty();
        }
        setTimeout(function () {
          if (typeof window.updatePrice === 'function') {
            window.updatePrice();
          }
          if (window.abSyncStickyAtcFromMain) {
            window.abSyncStickyAtcFromMain(sectionId);
          } else {
            syncStickyBySectionIdFromDom(sectionId);
          }
        }, 0);
      }

      function patched(evt) {
        orig.call(this, evt);
        if (!this.$container || !this.$container.length) return;
        if (!this.$container.closest('.product-template--pdp').length) return;
        restoreAtcTextAfterTheme(this, evt);
      }
      patched.__abPatched = true;
      theme.Product.prototype._updateAddToCart = patched;
    })();

    function run() {
      $('.product-template--pdp[data-section-id]').each(function () {
        var $s = $(this);
        bindSection($s);
        bindStickyCartAb($s);
      });
    }
    setTimeout(run, 0);

    $(document).on('shopify:section:load', function (e) {
      var $s = $(e.target).find('.product-template--pdp[data-section-id]');
      if ($s.length) {
        $s.each(function () {
          var $el = $(this);
          var sid = $el.attr('data-section-id');
          $el.removeData('abStickyAtc-' + sid);
          $el.removeData('stickyCartAbBound');
          registerAbSyncStickyAtc($el);
        });
        setTimeout(function () {
          $s.each(function () {
            bindSection($(this));
            bindStickyCartAb($(this));
          });
        }, 0);
        if (typeof window._abGpoTotalObsRetry === 'function') {
          window._abGpoTotalObsRetry();
        }
      }
    });

    /**
     * AB products only: GPO/ASG does not call theme updatePrice. Refresh ATC + cross-sell when
     * GPO selects change or .gpo-total-text updates (app may write totals async). Non-AB PDPs
     * rely on pdp-custom.js; do not add this logic there.
     */
    (function abGpoAndAsgPriceRefresh() {
      if (!document.querySelector('.product-template--pdp')) {
        return;
      }

      var debounceMs = 120;
      var timer = null;
      var tick48 = null;

      function runPriceRefresh() {
        if (typeof window.updatePrice === 'function') {
          window.updatePrice();
        }
        if (typeof window.__crosssellAbOnMainQtyChain === 'function') {
          window.__crosssellAbOnMainQtyChain();
        }
      }

      function scheduleDebounced() {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          timer = null;
          runPriceRefresh();
        }, debounceMs);
      }

      function scheduleAsgAndAsyncGpo() {
        setTimeout(function () {
          runPriceRefresh();
        }, 0);
        if (tick48) {
          clearTimeout(tick48);
        }
        tick48 = setTimeout(function () {
          tick48 = null;
          runPriceRefresh();
        }, 48);
        scheduleDebounced();
      }

      function onGpoSelectInteraction(e) {
        if (!e.target || !e.target.closest) {
          return;
        }
        if (!e.target.closest('.product-template--pdp') || !e.target.closest('.gpo-app')) {
          return;
        }
        if (e.target.tagName !== 'SELECT') {
          return;
        }
        scheduleAsgAndAsyncGpo();
      }

      document.addEventListener('change', onGpoSelectInteraction, true);
      document.addEventListener('input', onGpoSelectInteraction, true);

      function bindGpoTotalTextObservers() {
        document.querySelectorAll('.gpo-total-text').forEach(function (el) {
          if (el.dataset.abGpoPriceObsBound) {
            return;
          }
          el.dataset.abGpoPriceObsBound = '1';
          var obs = new MutationObserver(function () {
            if (!el.closest || !el.closest('.product-template--pdp')) {
              return;
            }
            scheduleDebounced();
          });
          obs.observe(el, { childList: true, characterData: true, subtree: true });
        });
      }

      function runObs() {
        bindGpoTotalTextObservers();
      }

      runObs();
      [200, 600, 1400, 3000].forEach(function (ms) {
        setTimeout(runObs, ms);
      });

      window._abGpoTotalObsRetry = runObs;
    })();
  });
})(jQuery);
